import { version } from "../../package.json";

export function logThemeInfo() {
  console.log(`Lillojeux v${version} (${import.meta.env.MODE})`);
}
